export default "__VITE_ASSET__CA5nzZK0__"